import AccountScreen from '../navigation/AccountNavigator';
import ParkScreen from '../navigation/ParkNavigator';
import ServicesScreen from '../navigation/ServicesNavigator';
import DevScreen from './DevScreen';
import RideScreen from './RideScreen';

type ScreensType = {
  [key: string]: React.FC;
};

const screens: ScreensType = {
  parkScreen: ParkScreen,
  accountScreen: AccountScreen,
  rideScreen: RideScreen,
  servicesScreen: ServicesScreen,
  devScreen: DevScreen,
};

export default screens;
